import React from 'react'

import type { CompanyBrief } from '../../../api/companies/types'
import CompanyCard from './Card'
import Loading from '../layout/Loading'
import Grid from '../layout/Grid'
import NoResults from '../layout/NoResults'

type Props = { data: Array<CompanyBrief> | undefined | null, isLoading: boolean, error: Error | undefined }
const CompanyGrid: React.FC<Props> = ({ data, isLoading, error }) => {
  if(isLoading) return <Loading />
  if(error) return <div>{error.message}</div>
  if(!data || data.length === 0) return <NoResults />
  return (
    <Grid>
      {data.map((company) => (
        <CompanyCard key={company.name} id={company.id} logoSrc={company.logoSrc} name={company.name} industry={company.industry.name} sector={company.industry?.sector?.name} flagSrc={company.country.flagSrc} isPartner={company.isPartner} />
      ))}
    </Grid>
  )
}
export default CompanyGrid
